import request from '@/utils/request'

export function categoryList() {
  return request({
    url: '/event/category',
    method: 'post',
  })
}

export function eventList(data) {
  return request({
    url: '/event/list',
    method: 'post',
    data
  })
}

export function eventInfo(id) {
  return request({
    url: '/event/' + id,
    method: 'post',
  })
}

export function eventStat(id) {
  return request({
    url: '/event/stat/' + id,
    method: 'post',
  })
}

export function eventCustomer(id, data) {
  return request({
    url: '/event/stat/' + id + '/user',
    method: 'post',
    data
  })
}